<template>
  <PageTemplate>
    <Loader v-if="!isLoaded"/>
    <div v-else>
      <div class="d-flex justify-content-between">
        <h6 class="element-header">
          {{ $t('report_sick_days.title') }}
        </h6>
      </div>

      <div class="element-box">
        <h5 class="form-header mb-4">
          {{ $t('report_sick_days.list') }}
        </h5>


        <Search
            :filters="filters"
            :loading="isSearching"
            :userDropdown="userDropdown"
            :statusDropdown="holidayRequestStatus"
            @search="getPendingRequest"/>

        <PerPage :values="[10, 25, 50, 100]" @update:perPage="getPendingRequest"/>

        <div class="table-responsive overflow-auto pt-4">
          <table class="table table-striped">
            <thead>
            <tr>
              <th>Mitarbeiternr</th>
              <th>Vorname</th>
              <th>Nachname</th>
              <th>Start</th>
              <th>Ende</th>
              <th class="text-end">Anzahl der Tage</th>
              <th class="text-center">eAU</th>
              <th class="text-center">Arzttermin vereinbart</th>
              <th class="text-center">Status</th>
              <th class="text-center">HR Bestätigungsstatus</th>
              <th class="text-center">Standortleiter Bestätigungsstatus</th>
              <th style=" text-align: right; padding-right: 30px; min-width: 150px;">{{ $t('general.actions') }}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(request) in pendingRequests.data" :key="request.id">
              <td>{{ request?.user?.employeeNumber }}</td>
              <td>{{ request?.user?.firstName }}</td>
              <td>{{ request?.user?.lastName }}</td>
              <td>{{ request?.startDate }}</td>
              <td>{{ request?.endDate }}</td>
              <td class="text-end">{{ report?.numberOfDays }}</td>
              <td>{{ request?.eAu === 1 ? 'ja' : 'nein' }}</td>
              <td>{{ request?.doctorsAppointmentDate }}</td>
              <td class="text-center">
                <div class="d-flex align-items-center">
                  <div v-if="request?.status === 'pending'"
                       class="status-pill yellow p-2 me-2" data-title="{{request?.statusTranslation}}"
                       data-bs-toggle="tooltip">
                  </div>
                  <span v-if="request.status === 'pending'">{{ request?.statusTranslation }}</span>
                </div>
                <div class="d-flex align-items-center">
                  <div v-if="request?.status === 'approved'"
                       class="status-pill green p-2 me-2" data-title="{{request?.statusTranslation}}"
                       data-bs-toggle="tooltip">
                  </div>
                  <span v-if="request?.status === 'approved'">{{ request?.statusTranslation }}</span>
                </div>
                <div class="d-flex align-items-center">
                  <div v-if="report?.status === 'declined'"
                       class="status-pill red p-2 me-2" data-title="{{request?.statusTranslation}}"
                       data-bs-toggle="tooltip">
                  </div>
                  <span v-if="request.status === 'declined'">{{ request?.statusTranslation }}</span>
                </div>
              </td>

              <td class="text-center">
                <div class="ps-3 d-flex align-items-center">
                  <template v-if="request?.oldLogic">
                    <div class="status-pill green p-2 me-2"
                         data-title="Genehmigt"
                         data-bs-toggle="tooltip"></div>
                    <span v-if="request.deleted">Abgelehnt</span>
                    <span v-else>Genehmigt</span>
                  </template>
                  <template v-else>
                    <template v-if="request?.hrApprove === null">
                      <div class="status-pill yellow p-2 me-2"
                           data-title="Anstehend"
                           data-bs-toggle="tooltip"></div>
                      Anstehend
                    </template>
                    <template v-else-if="request?.hrApprove === true">
                      <div class="status-pill green p-2 me-2"
                           data-title="Genehmigt"
                           data-bs-toggle="tooltip"></div>
                      Genehmigt
                    </template>
                    <template v-else-if="request?.hrApprove === false">
                      <div class="status-pill red p-2 me-2"
                           data-title="Abgelehnt"
                           data-bs-toggle="tooltip"></div>
                      Abgelehnt
                    </template>
                  </template>
                </div>
              </td>

              <td class="text-center">
                <div class="ps-3 d-flex align-items-center">
                  <template v-if="request?.oldLogic">
                    <div class="status-pill green p-2 me-2"
                         data-title="Genehmigt"
                         data-bs-toggle="tooltip"></div>
                    <span v-if="request.deleted">Abgelehnt</span>
                    <span v-else>Genehmigt</span>
                  </template>

                  <template v-else>
                    <template v-if="request?.coordinatorApprove === null">
                      <div class="status-pill yellow p-2 me-2"
                           data-title="Anstehend"
                           data-bs-toggle="tooltip"></div>
                      Anstehend
                    </template>
                    <template v-else-if="request?.coordinatorApprove === true">
                      <div class="status-pill green p-2 me-2"
                           data-title="Genehmigt"
                           data-bs-toggle="tooltip"></div>
                      Genehmigt
                    </template>
                    <template v-else-if="request?.coordinatorApprove === false">
                      <div class="status-pill red p-2 me-2"
                           data-title="Abgelehnt"
                           data-bs-toggle="tooltip"></div>
                      Abgelehnt
                    </template>
                  </template>
                </div>
              </td>
              <td class="text-end">
                <button class="btn btn-primary" @click="router.push({
                   name: 'reportSickDaysUserOverviewV2', params: {overviewUserId: request.user.id } })">
                  Übersicht
                </button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <Pagination
            v-if="pendingRequests?.pagination?.total_pages > 1"
            :totalPages="pendingRequests?.pagination?.total_pages"
            :currentPage="pendingRequests?.pagination?.current_page"
            @pagechanged="getPendingRequest"/>
      </div>
    </div>
  </PageTemplate>
</template>


<script setup>
import reportSickDaysService from '@/api/ReportSickDays';
import Loader from '@/components/Loader.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import Pagination from '@/components/Pagination.vue';
import PerPage from '@/components/PerPage.vue';
import { CloseToast, ErrorToast } from '@/components/VueToast';
import router from '@/router';
import { getUsersForHrOverviewDropdown } from '@/shared/dropdowns';
import { piniaEnumsStore } from '@/store/piniaEnumsStore';
import Search from '@/views/App/ReportSickDays/V1/Search.vue';
import { computed, onMounted, ref } from 'vue';

const piniaEnumsState                 = piniaEnumsStore();
const { holidayRequestStatus } = computed(() => piniaEnumsState.enums).value;

const filters = ref({
  userId: '',
  startDate: '',
  endDate: '',
  thisWeek: false,
  status: 'pending'
});

const pendingRequests = ref([]);
const userDropdown    = ref([]);
const isSearching     = ref(false);
const isLoaded        = ref(false);

async function getPendingRequest(page = 1, perPage, passedFilters) {
  CloseToast();

  if (passedFilters) {
    isSearching.value = true;
  }
  const perPageRes = pendingRequests.value?.pagination?.items_per_page;

  try {
    const { data } = await reportSickDaysService.getPendingRequestV2({
      page: page,
      limit: perPage ?? perPageRes,
      ...(passedFilters ? passedFilters : filters.value),
    });

    pendingRequests.value = data;
    isSearching.value     = false;
  } catch (error) {
    await ErrorToast(error);
    isSearching.value = false;
  }
}

onMounted(async () => {
  await Promise.all([
    getPendingRequest(),
    getUsersForHrOverviewDropdown(userDropdown),
  ]);

  isLoaded.value = true;
});

</script>

<style scoped>

</style>